import React from 'react';
import OrderBook from '../components/trading/OrderBook';
import './OrderBookPage.css';

/**
 * Order Book Page for Retail Frontend
 */
const OrderBookPage: React.FC = () => {
  return (
    <div className="orderbook-page">
      <div className="orderbook-page-header">
        <h1>Order Book</h1>
        <p>View real-time market depth for trading pairs</p>
      </div>
      <OrderBook />
    </div>
  );
};

export default OrderBookPage;

